var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57153 8.28577C8.57153 6.07663 10.3624 4.28577 12.5715 4.28577H30.8573L39.4287 12.8572V39.7143C39.4287 41.9235 37.6378 43.7143 35.4287 43.7143H12.5715C10.3624 43.7143 8.57153 41.9235 8.57153 39.7143V8.28577Z",
    fill: "url(#paint0_linear_3069_9406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8573 12.8572L39.4287 12.8572L30.8573 4.28575L30.8573 10.8572C30.8573 11.9617 31.7527 12.8572 32.8573 12.8572Z",
    fill: "#9271D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9991 21.4537C29.9991 20.3644 28.9964 19.5513 27.9306 19.7764L22.44 20.9358C21.2509 21.187 20.3999 22.2364 20.3999 23.4518V28.7754C19.9702 28.4527 19.4361 28.2615 18.8573 28.2615C17.4372 28.2615 16.2859 29.4128 16.2859 30.8329C16.2859 32.2531 17.4372 33.4043 18.8573 33.4043C20.2775 33.4043 21.4287 32.2531 21.4287 30.8329C21.4287 30.8203 21.4287 30.8077 21.4285 30.7951V23.4518C21.4285 22.7225 21.9391 22.0929 22.6526 21.9422L28.1431 20.7828C28.5694 20.6927 28.9705 21.018 28.9705 21.4537V27.0605C28.5409 26.7382 28.0071 26.5472 27.4287 26.5472C26.0086 26.5472 24.8573 27.6985 24.8573 29.1186C24.8573 30.5388 26.0086 31.6901 27.4287 31.6901C28.8489 31.6901 30.0002 30.5388 30.0002 29.1186C30.0002 29.0866 29.9996 29.0548 29.9984 29.0231H29.9991V21.4537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9406",
    x1: 24.0001,
    y1: 43.7143,
    x2: 24.0001,
    y2: 4.28577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9271D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A40BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3Icon);
export default __webpack_public_path__ + "static/media/mp3-icon.e32d94943be18751b920aa6d70006151.svg";
export { ForwardRef as ReactComponent };